import { PageLink, PageTitle } from '_metronic/layout/core';
import { FC } from 'react';
import { useLocation } from 'react-router-dom';
import { DepartamentosView } from './components/departamentosView';

const DepartamentosPage: FC = () => {
  let location = useLocation();
  const breadCrumbs: Array<PageLink> = [
    {
      title: 'Configuración',
      path: location.pathname,
      isSeparator: false,
      isActive: true,
    },
    {
      title: 'Departamentos',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ];

  return (
    <>
      <PageTitle breadcrumbs={breadCrumbs}>Departamentos</PageTitle>
      <DepartamentosView/>
    </>
  );
};

export {DepartamentosPage}